import { MessageBarGroup } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Notification } from '../../models';
import { CustomMessageBar } from './CustomMessageBar';
import './Notifications.scss';

interface NotificationsProps {
  notifications: Notification[];
}

const NotificationsImpl: React.FC<NotificationsProps> = (props) => {
  const { notifications } = props;

  const showDismissButton = (notification: Notification): boolean => {
    return notification.locationCode !== 'winner-resource';
  }

  return (
    <MessageBarGroup
      className='notifications'
    >
      {
        notifications.map((notification) => (
          <CustomMessageBar
            key={notification.notificationId}
            notificationTypeCode={notification.typeCode}
            message={notification.message}
            showDismissButton={showDismissButton(notification)}
          />
        ))
      }
    </MessageBarGroup>
  )
}

export const Notifications = observer(NotificationsImpl);
